import { isDefined } from "../utils";
import { SupportResistance as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    const supportResistanceData = [];

    for (let i = 0; i < data.length; i++) {
      const quote = data[i];

      // Check if we have valid data
      if (
        !quote ||
        !isDefined(quote.high) ||
        !isDefined(quote.low) ||
        !isDefined(quote.close)
      ) {
        supportResistanceData.push(undefined);
        continue;
      }

      const H = quote.high;
      const L = quote.low;
      const C = quote.close;

      // Validate that we have numeric values
      if (
        typeof H !== "number" ||
        typeof L !== "number" ||
        typeof C !== "number" ||
        !Number.isFinite(H) ||
        !Number.isFinite(L) ||
        !Number.isFinite(C)
      ) {
        supportResistanceData.push(undefined);
        continue;
      }

      // Support and Resistance calculation based on ChartIQ formula:
      // Original ChartIQ formula from research:
      // var M = ( H + L + C ) / 3;
      // var S = M + ((-L + (2 * M) - (-H + 2 * M)));
      // var R = M - ((-L + (2 * M)) - (-H + 2 * M));
      //
      // Simplified to:
      // M = (H + L + C) / 3
      // S = M + (H - L) = (2H + C - L) / 3
      // R = M - (H - L) = (2L + C + H) / 3
      const M = (H + L + C) / 3;
      const support = M + (H - L);
      const resistance = M - (H - L);

      supportResistanceData.push({
        support: support,
        resistance: resistance,
      });
    }

    return supportResistanceData;
  }

  calculator.undefinedLength = function () {
    return 0; // No lookback period needed - uses current bar only
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
